var scope_0 = require('/home/nodecomposite/clients/nodecomposite/blog-nodecomposite-com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2e6ad3c3aa5b05173aef5a85ad3d63e3.js').default;
var scope_1 = require('/home/nodecomposite/clients/nodecomposite/blog-nodecomposite-com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/501335d8e31f7da4d2484b7f2f10f8eb.js').default;
var scope_2 = require('/home/nodecomposite/clients/nodecomposite/blog-nodecomposite-com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    